import { ComponentProps, HTMLAttributes } from 'react';
import { joinClassNames } from '../../utils';
import styles from './Breadcrumb.module.scss';
import { ArrowLeftIcon } from '../Graphics';
import { E1Link } from '../E1Link';

export const BreadcrumbSeperator = (props: ComponentProps<typeof ArrowLeftIcon>) => (
  <ArrowLeftIcon role="none" focusable="false" {...props} />
);

export const BreadcrumbItem = E1Link;

export const Breadcrumb = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  const classNames = joinClassNames(styles.breadcrumb, className);
  return <div className={classNames} {...props} />;
};
